import React, {Component} from 'react';
import {Modal} from "react-bootstrap";
import {request} from "../helper/APIUtils";
import {showAxiosError} from "../helper/helper";
import moment from 'moment';
import TextOverFlowTooltip from "./TextOverFlowTooltip";
import DetailedSearch from "./DetailedSearch/DetailedSearch";
import Table from "./Table/Table";
import ExcelExporter from "./ExcelExporter";
import * as headerContent from "../constants/exportcontent";

class DeniedInboxWithErrorList extends Component {

	constructor(props) {
		super(props);
		this.state = {
			content: this.props.outboxDeniedContent ? this.props.outboxDeniedContent : [],
			total: this.props.outboxDeniedTotal ? this.props.outboxDeniedTotal : 0,
			loading: false,
			page: 0,
			size: 10,
			searchQuery: undefined
		};
		this.fetchData = this.fetchData.bind(this);
		this.handleSearch 	= this.handleSearch.bind(this);
	}


	fetchData(accessor, direction, page, size) {
		let self = this;
		let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '';
		let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
		let params = {
			url: '/outboxDenied/fetch?page=' + page + '&size=' + size + sortStr + searchQuery,
			method: "post"
		};

		self.setState({loading: true, manual: self.manual === true ? false: self.manual});

		request(params)
			.then(function (response) {
				self.setState({
					page: page,
					size: size,
					total: response.data.totalElements,
					content: response.data.content,
					loading: false,
					searching: false
				});
			}).catch(function (error) {
			self.setState({loading: false,searching: false});
			showAxiosError(error);
		});
	}

	handleSearch(searchQuery) {
		this.setState({searchQuery, searching: true}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
	}

	render() {
		const columns = [
			{
				Header: "Gönderici VKN/TCKN",
				accessor:"inbox.sourceId",
				Cell: row => (<div><TextOverFlowTooltip text={row.inbox && row.inbox.sourceId ? row.inbox.sourceId :""} maxLength={11}></TextOverFlowTooltip></div>),

				sortable:false
			},
			{
				Header: "Gönderici Ünvan",
				accessor:"inbox.sourceTitle",
				sortable:false,
				Cell: row => (<div><TextOverFlowTooltip text={row.inbox && row.inbox.sourceTitle ? row.inbox.sourceTitle :""} maxLength={23}></TextOverFlowTooltip></div>)

			},
			{
				Header: "Alım Tarihi",
				accessor:"inbox.receivedDate",
				Cell: row => (<div>{moment(row.inbox.receivedDate).isValid() ? moment(row.inbox.receivedDate).format("DD-MM-YYYY HH:mm:ss") : '-'}</div>),
				sortable:false
			},
			{
				Header: "Alıcı VKN/TCKN",
				accessor:"sourceId"
			},
			{
				Header: "Alıcı Ünvan",
				accessor:"sourceTitle",
				sortable:false,
				Cell: row => (<div><TextOverFlowTooltip text={row.sourceTitle ? row.sourceTitle :""} maxLength={23}></TextOverFlowTooltip></div>)
			},
			{
				Header: "Cevaplama Tarihi",
				accessor:"documentIssueDate",
				Cell: row => (<div>{moment(row.documentIssueDate).isValid() ? moment(row.documentIssueDate).format("DD-MM-YYYY HH:mm:ss") : '-'}</div>)
			},
			{
				Header: "İşlem Durumu",
				accessor:"processState",
				sortable:false,
			},
			{
				Header: "Sonuç Açıklaması",
				accessor:"resultExplanation",
				Cell: row => (<div><TextOverFlowTooltip text={row.resultExplanation ? row.resultExplanation :""} maxLength={23}></TextOverFlowTooltip></div>),
				sortable:false,
			},

		];

		const fields = [
			{
				label: "VKN/TCKN",
				accessor: "sourceId",
				type: "numericText",
				operator: "=",
			},
			{
				label: "Ünvan",
				accessor: "sourceTitle",
				type: "text",
				operator: "=",
			},
			{
				label: "Başlangıç",
				accessor: "min_documentIssueDate",
				type: "date",
				operator: ">=",
			},
			{
				label: "Bitiş",
				accessor: "max_documentIssueDate",
				type: "date",
				operator: "<=",
			}

		];

        const defaultHeaders = headerContent.faultyOutboxDeniedContent;
		return (
			<Modal show={this.props.showDeniedInboxWithError} onHide={this.props.close} size='xl'>
				<Modal.Header closeButton style={{padding: '22px 25px'}}>Son 7 Gün İçinde Red İşlemi Hata Alan Faturalar</Modal.Header>
				<Modal.Body>
					<div className="col-sm-12">

						<div className="card-header">

							<h4 className="card-title">
								{!this.props.forHomePage
									?
									"Son 7 Gün İçinde Red İşlemi Hata Alan Faturalar"
									:
									"Red cevabı verdiğiniz aşağıdaki faturalarınıza alıcı tarafından hata dönülmüş. " +
									"Tekrar cevaplayabilir, eğer hata almaya devam ederseniz alıcı ile görüşebilirsiniz."
								}
							</h4>
						</div>

						{ !this.props.forHomePage &&
						<div className="card-body">
							<DetailedSearch fields={fields}
											loading={this.state.searching}
											onSearch={this.handleSearch}/>
						</div>
						}

						<div className="card-body row">
							<Table columns={columns}
								   loading={this.state.loading}
								   loadingText="Kayıtlar getiriliyor..."
								   content={this.state.content}
								   total={this.state.total}
								   page={this.state.page}
								   manual={this.state.manual}
								   size={this.state.size}
								   options={["5", "10", "20", "50", "100"]}
								   fetchData={(this.props.source && this.props.source !== "homepage") && this.fetchData}
							/>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
						<div>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{
										background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
										padding: '10px 54px 10px 23px'
									}}
									rel="tooltip" className="TekBtn vazgec btn-icon"
									onClick={this.props.close}>
								Kapat
							</button>
						</div>

						<div>
                            <ExcelExporter position="leftSide"
                                           url={this.state.searchQuery ? '/outboxDenied/exportXls?sort=createdAt,desc&' + this.state.searchQuery : '/outboxDenied/exportXls?sort=createdAt,desc'}
                                           sheetName='Red_Islemi_Hata_Alan_Faturalar'
                                           title="Excel'e Aktar"
                                           defaultHeaders={defaultHeaders}
                                           icon='excel'
                                           type='faultyOutboxDenied'
										   source={this.props.source}
                                           completeFetch={true}
                                           longButton = {true}
                                           props = {this.state.loading}/>
						</div>
					</div>
				</Modal.Footer>
			</Modal>
		)
	}


}

export default DeniedInboxWithErrorList;